/**
 * @generated SignedSource<<72f13645fa2b34d9c7efeada9b46a59a>>
 * @lightSyntaxTransform
 * @nogrep
 */
/* tslint:disable */
/* eslint-disable */
// @ts-nocheck
import { ConcreteRequest } from 'relay-runtime';

export type ApplyReferralCodeError =
  | 'ALREADY_APPLIED'
  | 'EXHAUSTED'
  | 'INACTIVE'
  | 'INELIGIBLE'
  | 'NOT_FOUND'
  | 'PROMOTION_CONFLICT'
  | 'UNEXPECTED_ERROR'
  | '%future added value';
export type ReferralProduct =
  | 'GOLD_CARD_24_K_REFERRAL'
  | 'RH_CREDIT_APPLICATION'
  | 'THRIVE_CASH'
  | 'X_1_ANNOUNCEMENT_WAITLIST'
  | 'X_1_CREDIT_APPLICATION'
  | 'X_1_PLUS_WAITLIST'
  | 'X_1_WAITLIST'
  | '%future added value';
export type ApplyReferralCodeRequest = {
  code: string;
  email?: string | null;
  identityId?: string | null;
  product: ReferralProduct;
};
export type TermsAndConditionsPageApplyReferralCodeMutation$variables = {
  q: ApplyReferralCodeRequest;
};
export type TermsAndConditionsPageApplyReferralCodeMutation$data = {
  readonly applyReferralCode: {
    readonly data: {
      readonly id: string;
    } | null;
    readonly errors2: ReadonlyArray<{
      readonly error?: ApplyReferralCodeError;
      readonly subtitle?: string | null;
      readonly title?: string | null;
    }>;
  };
};
export type TermsAndConditionsPageApplyReferralCodeMutation = {
  response: TermsAndConditionsPageApplyReferralCodeMutation$data;
  variables: TermsAndConditionsPageApplyReferralCodeMutation$variables;
};

const node: ConcreteRequest = (function () {
  var v0 = [
      {
        defaultValue: null,
        kind: 'LocalArgument',
        name: 'q',
      },
    ],
    v1 = [
      {
        kind: 'Variable',
        name: 'q',
        variableName: 'q',
      },
    ],
    v2 = {
      alias: null,
      args: null,
      concreteType: 'ReferralCode',
      kind: 'LinkedField',
      name: 'data',
      plural: false,
      selections: [
        {
          alias: null,
          args: null,
          kind: 'ScalarField',
          name: 'id',
          storageKey: null,
        },
      ],
      storageKey: null,
    },
    v3 = {
      kind: 'InlineFragment',
      selections: [
        {
          alias: null,
          args: null,
          kind: 'ScalarField',
          name: 'error',
          storageKey: null,
        },
        {
          alias: null,
          args: null,
          kind: 'ScalarField',
          name: 'title',
          storageKey: null,
        },
        {
          alias: null,
          args: null,
          kind: 'ScalarField',
          name: 'subtitle',
          storageKey: null,
        },
      ],
      type: 'ValidationApplyReferralCodeErrorType',
      abstractKey: null,
    };
  return {
    fragment: {
      argumentDefinitions: v0 /*: any*/,
      kind: 'Fragment',
      metadata: null,
      name: 'TermsAndConditionsPageApplyReferralCodeMutation',
      selections: [
        {
          alias: null,
          args: v1 /*: any*/,
          concreteType: 'ApplyReferralCodeValidation',
          kind: 'LinkedField',
          name: 'applyReferralCode',
          plural: false,
          selections: [
            v2 /*: any*/,
            {
              alias: null,
              args: null,
              concreteType: null,
              kind: 'LinkedField',
              name: 'errors2',
              plural: true,
              selections: [v3 /*: any*/],
              storageKey: null,
            },
          ],
          storageKey: null,
        },
      ],
      type: 'Mutation',
      abstractKey: null,
    },
    kind: 'Request',
    operation: {
      argumentDefinitions: v0 /*: any*/,
      kind: 'Operation',
      name: 'TermsAndConditionsPageApplyReferralCodeMutation',
      selections: [
        {
          alias: null,
          args: v1 /*: any*/,
          concreteType: 'ApplyReferralCodeValidation',
          kind: 'LinkedField',
          name: 'applyReferralCode',
          plural: false,
          selections: [
            v2 /*: any*/,
            {
              alias: null,
              args: null,
              concreteType: null,
              kind: 'LinkedField',
              name: 'errors2',
              plural: true,
              selections: [
                {
                  alias: null,
                  args: null,
                  kind: 'ScalarField',
                  name: '__typename',
                  storageKey: null,
                },
                v3 /*: any*/,
              ],
              storageKey: null,
            },
          ],
          storageKey: null,
        },
      ],
    },
    params: {
      cacheID: '92008fe29f86b5c300612c2b493c50ae',
      id: null,
      metadata: {},
      name: 'TermsAndConditionsPageApplyReferralCodeMutation',
      operationKind: 'mutation',
      text: 'mutation TermsAndConditionsPageApplyReferralCodeMutation(\n  $q: ApplyReferralCodeRequest!\n) {\n  applyReferralCode(q: $q) {\n    data {\n      id\n    }\n    errors2 {\n      __typename\n      ... on ValidationApplyReferralCodeErrorType {\n        error\n        title\n        subtitle\n      }\n    }\n  }\n}\n',
    },
  };
})();

(node as any).hash = '0bfb2d6d6aa5a3cc545e7c8bc95fbcb5';

export default node;
